var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header __container"},[_c('a-logo'),_c('div',{staticClass:"center"},[_c('header-nav')],1),_c('div',{staticClass:"right"},[_c('drawer-view',{on:{"view":function($event){_vm.drawer=true}}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }